import * as React from 'react';

import { cn } from '@sara/ui/lib/utils';

/**
 * AI Interviewer brand mark — five filled equalizer bars with the peak
 * (second-to-last) bar in the primary color. The bars sit inside a
 * rounded-square frame drawn with CSS so it can animate on hover or
 * group-hover.
 */
const Logo = React.forwardRef<HTMLDivElement, React.HTMLAttributes<HTMLDivElement>>(
  ({ className, ...props }, ref) => (
    <div
      ref={ref}
      className={cn(
        'inline-flex h-11 w-11 items-center justify-center rounded-lg border border-border bg-card p-1.5 transition-colors duration-200 ease-out',
        'hover:border-foreground/35',
        'group-hover:border-foreground/35',
        className
      )}
      {...props}
    >
      <svg
        viewBox="0 0 64 64"
        xmlns="http://www.w3.org/2000/svg"
        className="h-full w-full"
        aria-hidden
      >
        <g className="fill-foreground/30">
          <rect x="6" y="26" width="8" height="12" rx="4" />
          <rect x="17" y="14" width="8" height="36" rx="4" />
          <rect x="28" y="22" width="8" height="20" rx="4" />
          <rect x="50" y="24" width="8" height="16" rx="4" />
        </g>
        <rect x="39" y="8" width="8" height="48" rx="4" className="fill-primary" />
      </svg>
    </div>
  )
);
Logo.displayName = 'Logo';

export { Logo };
